export default function GeneralWarningPopUp(props) {
    return (
        <>
    
                <div className="delete-warning-rpt">
                    <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                        <div className="modal-dialog modal-xl" role="document">
                            <div className="modal-content">
                            <div className="modal-header pt-0 p-0 mb-4 ">
                                <h5 className="modal-title pl-2" style={{ fontSize: "16px" }}>{props.title}</h5>
                                <button type="button" className="close mr-1 pr-0" onClick={props.onClose} aria-label="Close" >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                            <div className="modal-body" style={{ fontSize: "14px" }}>
                                    <h6 className="delete-warning">{props.warning}</h6>
                                </div>
                                <div className="modal-footer">
                                <button type="button" className="ISBNSubmit mr-2" onClick={props.option1Action} >{props.option1}</button>
                                <button type="button" className="ISBNSubmit ml-2" onClick={props.onClose} >{props.option2}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-backdrop fade show"></div>
                </div>
            
        </>
    )
}